module.exports = __webpack_public_path__ + "static/media/support-us.5e71a9fc.svg";